import React from 'react';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { contact, marquee } from '../mock';

const CTA = ({ onQuote }) => {
  return (
    <section className="relative">
      <div className="relative overflow-hidden bg-gradient-to-br from-emerald-500 via-emerald-600 to-emerald-700">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(white 1px, transparent 1px)', backgroundSize: '24px 24px' }} />
        <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-white/10 blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-8 items-center">
          <div className="text-white">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur text-white text-xs font-semibold uppercase tracking-widest">
              Ready to Switch?
            </div>
            <h2 className="mt-5 text-4xl md:text-5xl font-extrabold leading-tight">
              Power your business with green energy.
            </h2>
            <p className="mt-5 text-emerald-50 text-lg leading-relaxed max-w-xl">
              Get a free site assessment and a personalised quote from our renewable-energy specialists.
            </p>
          </div>
          <div className="flex flex-wrap gap-4 justify-start lg:justify-end">
            <button onClick={onQuote} className="inline-flex items-center gap-2 bg-white text-emerald-700 hover:bg-[#0b1a1a] hover:text-white px-7 py-3.5 rounded-full font-bold shadow-xl transition-colors">
              Contact Now <ArrowRight className="w-4 h-4" />
            </button>
            <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noreferrer"
               className="inline-flex items-center gap-2 bg-[#0b1a1a] text-white hover:bg-emerald-900 px-7 py-3.5 rounded-full font-bold transition-colors">
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="bg-[#0b1a1a] text-white py-6 overflow-hidden">
        <div className="flex gap-12 animate-[marquee_25s_linear_infinite] whitespace-nowrap">
          {[...marquee, ...marquee, ...marquee].map((m, i) => (
            <div key={i} className="flex items-center gap-12">
              <span className="text-2xl md:text-3xl font-extrabold tracking-tight">{m}</span>
              <span className="w-2 h-2 rounded-full bg-emerald-400" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTA;
